import React from 'react'
import { StyledLine } from './styles'

export default function Line() {
  return <StyledLine data-testid="lineComponent" />
}
